module.exports = __webpack_public_path__ + "img/596.2444a086.png";